import { render, staticRenderFns } from "./sDataLaborEdit.vue?vue&type=template&id=25be65f4&scoped=true"
import script from "./sDataLaborEdit.vue?vue&type=script&lang=js"
export * from "./sDataLaborEdit.vue?vue&type=script&lang=js"
import style0 from "./sDataLaborEdit.vue?vue&type=style&index=0&id=25be65f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be65f4",
  null
  
)

export default component.exports